var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"header",attrs:{"id":"header"}},[_c('div',{staticClass:"header__wrapper"},[_vm._m(0),_c('div',{staticClass:"header__info"},[_c('sign-block')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header__logo"},[_c('a',{attrs:{"href":"/"}},[_c('span',{staticClass:"header__logo-link header__logo-img"})])])
}]

export { render, staticRenderFns }